var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9868 3.36874C12.4332 3.1994 11.8454 3.10829 11.2363 3.10829C7.93524 3.10829 5.25927 5.78431 5.25927 9.0853L5.25927 13.6769C5.25927 14.7641 3.76501 14.7641 3.76501 16.2577C3.76501 17.0829 4.43395 17.752 5.25927 17.752H17.2133C18.0385 17.752 18.7075 17.0829 18.7075 16.2577C18.7075 14.7616 17.2133 14.7616 17.2133 13.6769V13.2692",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5542 21.1083H13.9228",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2018 7.48819C20.2018 9.19553 18.8178 10.5796 17.1104 10.5796C15.4031 10.5796 14.019 9.19553 14.019 7.48819C14.019 5.78085 15.4031 4.39679 17.1104 4.39679C18.8178 4.39679 20.2018 5.78085 20.2018 7.48819Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNotification;